// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zai-hero-title {
  color: var(--base_color1);
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  letter-spacing: 0;
  text-align: center;
}
.zai-hero-title .zai-hero-title-brand-link {
  color: var(--color_primary_500);
  text-decoration: none;
}
.zai-hero-title .zai-hero-title-brand-link:hover {
  text-decoration: underline;
}
.zai-hero-title .zai-hero-title-verified-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  color: #3897f0;
  vertical-align: middle;
  margin-left: 4px;
}`, "",{"version":3,"sources":["webpack://./src/modules/zai/zai-hero-title/zai-hero-title.styles.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AACF;AACE;EACE,+BAAA;EACA,qBAAA;AACJ;AACI;EACE,0BAAA;AACN;AAGE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;AADJ","sourcesContent":[".zai-hero-title {\n  color: var(--base_color1);\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 48px;\n  letter-spacing: 0;\n  text-align: center;\n\n  .zai-hero-title-brand-link {\n    color: var(--color_primary_500);\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  .zai-hero-title-verified-icon {\n    width: 20px;\n    height: 20px;\n    flex-shrink: 0;\n    color: #3897f0;\n    vertical-align: middle;\n    margin-left: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
